
import { importSync as i } from '@embroider/macros';
let d = window.define;
import "@warp-drive/core/-embroider-implicit-modules.js";
import "@warp-drive/utilities/-embroider-implicit-modules.js";
import "@warp-drive/legacy/-embroider-implicit-modules.js";
import "@embroider/macros/-embroider-implicit-modules.js";
